$(function() {

  const $inputs = $('input[name^="filter.v.price"]');
  
  if($inputs.length > 0 ){

    $inputs.each(function () {
      const $input = $(this);
      let isComposing = false;

      // IME入力中フラグ
      $input.on('compositionstart', function () {
        isComposing = true;
      });

      $input.on('compositionend', function () {
        isComposing = false;
        sanitizeInput($input);
      });

      // 通常の入力時
      $input.on('input', function () {
        if (!isComposing) {
          sanitizeInput($input);
        }
      });
    });

    function sanitizeInput($input) {
      let val = $input.val();

      // 全角数字→半角数字に変換
      val = val.replace(/[０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      });

      // 半角数字以外を除去
      val = val.replace(/[^0-9]/g, '');

      $input.val(val);
    }
  }
  
  /*
  const $inputs = $('input[name^="filter.v.price"]');
  
  if($inputs.length > 0 ){

    function toHalfWidth(str) {
      return str.replace(/[！-～]/g, function(ch) {
        return String.fromCharCode(ch.charCodeAt(0) - 0xFEE0);
      }).replace(/　/g, " ");
    }

    function onlyNumbers(str) {
      return str.replace(/[^0-9]/g, '');
    }

    $inputs.on('input', function () {
      const $this = $(this);
      const original = $this.val();
      const converted = onlyNumbers(toHalfWidth(original));
      console.log(original);
      console.log(converted);
      
      if (original !== converted) {
        $this.val(converted);
      }
    });

    $inputs.on('paste', function (e) {
      e.preventDefault();
      const pasted = (e.originalEvent.clipboardData || window.clipboardData).getData('text');
      const clean = onlyNumbers(toHalfWidth(pasted));
      $(this).val(clean);
    });
  }
  */
  
$('header-menu > details').hover(
  function (){
    if (window.matchMedia( "(min-width: 768px)" ).matches) { 
      $(this).attr('open', true);
      $(this).children(".header__menu-item").attr('aria-expanded', true);
    }	
  },
  function () {
    if (window.matchMedia( "(min-width: 768px)" ).matches) { 
      $(this).attr('open', false);
      $(this).children(".header__menu-item").attr('aria-expanded', false);
    }
  }
);  
  
  
	$('summary.menu-drawer__menu-item').click(function(){
		$(this).toggleClass("is-open");
		
	});	

//固定ボタン
  $(document).on('click', '#fixed_product_request_btn', function(){
      $('.globo-form-app').addClass("active");

  });
//未ログイン時のポップアップ
  const modal = $('.request_modal_content');
  const overlay = $('.request_modal_overlay');

  $(document).on('click', '#fixed_product_request_btn_no', function(){
    modal.addClass("open");
    overlay.addClass("open");
  });

  $('.request_modal_delete').on('click', function(){
    modal.removeClass("open");
    overlay.removeClass("open");
  });
  overlay.on('click', function(){
    modal.removeClass("open");
    overlay.removeClass("open");
  });


    $(".footer a[href]").each(function () {
        if (!this.href.match(new RegExp("^(#|\/|(https?:\/\/" + location.hostname + "))"))) {
            // ドメインが違うリンクの場合にaにtarget="_blank"を付与.
            $(this).attr("target", "_blank");

            // external_linkのクラスを付与。こちらでCSS等でアイコンを表示させる
            $(this).addClass("external_link");
        }
    });

})
